export const blbIdTip = '仅可选同当前网格实例VPC的BLB实例，1个BLB实例只能绑定1个网关实例';
